import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import HeroBG from "../../img/flight1.avif";
import HeroBackgroundAnimation from "../HeroBackgroundAnimation";
import RotatingGlobe from "../RotatingGlobe";
import ActionButtons from "../ActionButtons";

const slideInLeft = {
    hidden: { opacity: 0, x: -80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.8, ease: "easeOut" },
    },
};

const slideInRight = {
    hidden: { opacity: 0, x: 80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.8, ease: "easeOut" },
    },
};

const container = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.2 },
    },
};

export default function HeroSection() {
    return (
        <section
            style={{
                backgroundImage: `url(${HeroBG})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center center",
            }}
            className="md:bg-cover bg-contain mx-auto flex flex-col relative overflow-hidden bg-gradient-to-br from-[#0F5132] to-[#16a34a]"
        >
            <div className="absolute inset-0 bg-black/60 pointer-events-none" />
            <HeroBackgroundAnimation />

            <div className="relative pt-[110px] pb-10">
                <motion.div
                    variants={container}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    className="max-w-7xl mx-auto grid px-6 lg:px-16 lg:gap-8 xl:gap-0 lg:pt-10 lg:grid-cols-12"
                >
                    <motion.div variants={slideInLeft} className="mr-auto place-self-center lg:col-span-7">
                        <h1 className="md:block hidden max-w-2xl mb-6 text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-display-fran leading-[1.1] tracking-[-0.02em]">
                            Experiences Borderless
                            <br /> Payments, <span className="text-[#00C962]">Globally.</span>
                        </h1>
                        <h1 className="md:hidden block mb-6 text-[32px] text-white font-display-fran font-[600] leading-[1.1] tracking-[-0.02em]">
                            Experience<br /> Borderless Payments,<br />
                            <span className="text-[#00C962]">Globally.</span>
                        </h1>

                        <p className="md:block hidden max-w-lg mb-8 text-base sm:text-[16px] lg:text-[16px] text-white font-body font-medium leading-[1.6] tracking-wide opacity-80">
                            Send, receive, and spend money anywhere in the world effortlessly. Your all-in-one global wallet for multicurrency transactions.
                        </p>
                        <p className="md:hidden block mb-8 text-[14px] text-white font-body font-medium leading-[1.6] tracking-wide opacity-80">
                            Send, receive, and spend money anywhere in the world effortlessly. Your all-in-one global wallet for multicurrency transactions.
                        </p>

                        <div className="flex flex-row sm:space-x-4 space-x-4 sm:space-y-0">
                            <div className="flex items-center space-x-3">
                                <p className="text-[11px] sm:text-base font-medium text-white">Featured&nbsp;on</p>
                                <div className="flex space-x-3">
                                    <img src="/images/master2.png" alt="Mastercard" className="h-6 w-auto" />
                                    <img src="/images/light2.png" alt="Light" className="h-6 w-auto" />
                                </div>
                            </div>
                            <div className="flex items-center space-x-3">
                                <p className="text-[11px] sm:text-base font-medium text-white">Member</p>
                                <img src="/images/Fintech21-white.png" alt="Fintech21" className="lg:h-6 h-[20px] w-auto" />
                            </div>
                        </div>

                        <p className="text-[#ABF080] text-bold text-sm md:text-xl mt-4 text-wrap max-w-[400px]">AfriPay is Registered with FinCEN as a Money Services Business</p>

                        <div className="mb-6 mt-7">
                            <ActionButtons />
                        </div>
                    </motion.div>

                    <motion.div variants={slideInRight} className="my-6 lg:mt-0 lg:col-span-5 lg:flex w-full md:mt-0 mt-12 overflow-visible">
                        <div className="w-full h-[300px] md:h-[600px]">
                            <RotatingGlobe />
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
}